import { theme } from '@faxi/web-component-library';
import { flex, fontSize } from '@faxi/web-css-utilities';
import { Form } from '@faxi/web-form';
import styled from 'styled-components';

const StyledFindDealerForm = styled(Form)`
  .wcl-overlay {
    .wcl-modal {
      width: ${theme.sizes.SIZE_632};

      &__header {
        &__title {
          ${flex('row', 'center', 'center')};
          text-align: center;
        }
      }

      &__content {
        ${flex('column')}
        gap:${theme.sizes.SIZE_20};
        ${fontSize(theme.fontSizes.FONT_16)};
      }
    }
  }

  .cedolauto-find-dealer-form {
    &__desc {
      color: var(--BACKGROUND_2_1);
      font-weight: 500;
      flex: 1;

      &__title {
        font-size: ${theme.fontSizes.FONT_28};
        margin-bottom: ${theme.sizes.SIZE_8};
      }

      &__content {
        font-size: ${theme.fontSizes.FONT_20};
        margin-top: 0;
      }
    }

    &__actions {
      ${flex('row', 'space-between')};

      &__prev-step {
        svg {
          transform: rotate(90deg);
          margin-bottom: ${theme.sizes.SIZE_4};
        }
      }
    }

    &__button {
      color: var(--BACKGROUND_2_1);
    }

    &__successful-submission-modal {
      p {
        text-align: center;
        ${fontSize(theme.fontSizes.FONT_18)};
      }
    }

    &__privacy-policy {
      ${flex('row', 'flex-start', 'center')};
      gap: ${theme.sizes.SIZE_20};
      color: var(--BACKGROUND_2_1);

      &__button {
        color: var(--BACKGROUND_2_1);
        font-weight: 500;
        text-decoration: underline;
        margin-left: ${theme.sizes.SIZE_4};
      }
      .wcl-checkbox__box--checked {
        background-color: var(--PRIMARY_1_1);
        i,
        svg {
          color: var(--BACKGROUND_2_1);
        }
      }

      &__checkbox-label {
        .cedolauto-info-modal {
          display: inline-block;

          .wcl-modal {
            width: ${theme.sizes.SIZE_832};
            max-height: ${theme.sizes.SIZE_912};
          }
        }
      }
    }
  }
`;

export { StyledFindDealerForm };
